import React, { useState, useEffect } from 'react';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import { useSelector } from 'react-redux';
import { buildFilters } from 'global/utils/filter';
import { get } from 'global/lib/lodash';
import List from '@material-ui/core/List';
import { EditionListItem } from './EditionListItem';
import { sortByDate } from 'global/utils';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { EditionStatus } from 'global/lib/filter';
import { Text } from 'global/components/text';
import { CenterContent } from 'global/components/perform-grid';

const pageSize = 50;

export default function EditionList(props) {
  const hasRealm = useSelector((state) => get(state, 'auth.realm.id'));

  const filtId = 'library.editions';

  const filter = useSelector((state) => get(state, `filter.${filtId}`));

  const [urlParams, setUrlParams] = useState({
    build: ['editions'],
    waitFor: null,
    params: {
      page: { size: pageSize, number: 1 },
      ...buildFilters(filter, { includeRealm: false, convertName: { searchstring: 'name', status: 'active' }, dontFilter: ['courseStatus', 'start_date', 'end_date', 'edition_id', 'role'] }),
    },
  });
  const searchString = get(filter, 'searchstring', '');

  useEffect(() => {
    setUrlParams({
      ...urlParams,
      useEffect: true,
      waitFor: undefined,
      params: {
        ...urlParams.params,
        ...{ page: { size: pageSize, number: 1 } },
        ...buildFilters(filter, {
          includeRealm: false,
          convertName: { searchstring: 'name' },
          dontFilter: ['courseStatus', 'start_date', 'end_date', 'edition_id', 'role'],
          overrideFilter: (filt) => {
            if (!filt.status) {
              filt.status = EditionStatus.map((es) => es.value).join(',');
            }
            return filt;
          },
        }),
      },
    });
  }, [filter, hasRealm]);

  const editions = useRetrieveData({ url: `/editions` }, urlParams);

  const lastPage = get(editions, 'meta.page.last-page', null);
  const updatePage = (newPage) => {
    if (props.showCoursesInList) {
      return;
    }

    if (lastPage <= newPage) {
      setUrlParams({
        ...urlParams,
        params: {
          ...urlParams.params,
          page: { size: pageSize, number: newPage },
        },
      });
    }
  };

  const data = (() => {
    if (props.showCoursesInList) {
      return sortByDate([...(editions.data || []), ...(props.courses.data || []).filter((d) => !!d.edition).map((d) => ({ ...d, ...(d.edition || {}) }))], 'createdAt');
    }
    return sortByDate(editions.data || [], 'created-at');
  })();

  return (
    <CenterContent>
      <Text type="headline_small" bold>
        Reference
      </Text>
      <ListWithSearch
        {...props}
        handlePageChange={updatePage}
        currentPage={get(urlParams, 'params.page.number', 1)}
        lastPage={lastPage}
        filterString={searchString}
        loading={editions.loading}
        data={data}
        error={editions.error}
      />
    </CenterContent>
  );
}

const ListWithSearch = withInfiniteScroll(EditionListItem, List);
